import React, { useContext } from "react";
import { useLocation, useNavigate, createSearchParams } from "react-router-dom";
import StoreFormContainer from "components/store-form-container";
import { getQueryParams, isDropoffStore } from "lib/utils";
// import { useTranslation } from "react-i18next";
import { Header } from "components/header";
import AuthContext from "contexts/AuthContext";

export default function DropoffCaptureWeight() {
  // const { t } = useTranslation();
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = getQueryParams(location.search);

  const { user } = useContext(AuthContext);

  const handleSubmit = () => {
    isDropoffStore(user)
      ? navigate({
          pathname: `/en-US/store/trade-in-scan-weight/dropoff`,
          search: createSearchParams(queryParams).toString(),
        })
      : navigate({
          pathname: "/en-US/store/trade-in-scan-weight",
          search: createSearchParams(queryParams).toString(),
        });
  };

  return (
    <StoreFormContainer
      submitLabel="Continue"
      secondaryLabel="Back"
      secondaryHref="/en-US/store/trade-in-weight"
      secondaryParams={queryParams}
      onSubmit={handleSubmit}
    >
      <Header />
      <div className="flex justify-center flex-col flex-grow py-4">
        <div className="flex flex-col items-center">
          <h2 className="font-semibold text-4xl text-center mb-6">
            Weigh the trade-in
          </h2>

          <div className="w-full max-w-2xl space-y-6">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-8 h-8 bg-red text-white rounded-full flex items-center justify-center font-bold">
                1
              </div>
              <p className="text-lg">
                Guide the seller through the on-screen steps to weigh all their
                LEGO® bricks.
              </p>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-8 h-8 bg-red text-white rounded-full flex items-center justify-center font-bold">
                2
              </div>
              <p className="text-lg">
                If the seller has more than one tray of bricks, have them click{" "}
                <strong>Continue</strong> and accept that the contents will be
                cleared into the kiosk's accumulation box. Repeat this process
                for each tray of bricks.
              </p>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-8 h-8 bg-red text-white rounded-full flex items-center justify-center font-bold">
                3
              </div>
              <p className="text-lg">
                Once all bricks are weighed, <strong>scan the QR code</strong>{" "}
                on the summary screen with this device to finalize the trade-in.
              </p>
            </div>
          </div>
        </div>
      </div>
    </StoreFormContainer>
  );
}
